import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import StickerImage from './StickerImage';
import RoseImage from './RoseImage';
import { STYLE_ROSE, STYLE_STICKER } from 'utils/image/styles';
import { jsx as _jsx } from "react/jsx-runtime";
var BadgeImage = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? STYLE_STICKER : _ref$variant,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  switch (variant) {
    case STYLE_ROSE:
      {
        return /*#__PURE__*/_jsx(RoseImage, _objectSpread({
          ref: ref,
          "data-style": STYLE_ROSE
        }, otherProps));
      }
    case STYLE_STICKER:
    default:
      {
        return /*#__PURE__*/_jsx(StickerImage, _objectSpread({
          ref: ref,
          "data-style": STYLE_STICKER
        }, otherProps));
      }
  }
});
BadgeImage.displayName = 'BadgeImage';
export default BadgeImage;